var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBuildingEmbassy = function SvgBuildingEmbassy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.188v5.406c5.398 0 3.586 1.812 7.188 1.812H32V13h-1.812c-3.602 0-1.79-1.812-7.188-1.812M8.813 21A1 1 0 0 0 8 22v5H.906A.996.996 0 0 0 0 28v21c0 .55.45 1 1 1h48c.55 0 1-.45 1-1V28c0-.55-.45-1-1-1h-7v-5c0-.55-.45-1-1-1H8.812M10 23h30v4H10Zm-8 6h46v19H2Zm4 3v5h3v-5Zm7 0v5h3v-5Zm7 0v5h3v-5Zm7 0v5h3v-5Zm7 0v5h3v-5Zm7 0v5h3v-5ZM6 40v5h3v-5Zm7 0v5h3v-5Zm7 0v5h3v-5Zm7 0v5h3v-5Zm7 0v5h3v-5Zm7 0v5h3v-5Z"
  })));
};
export default SvgBuildingEmbassy;